import { Box, styled, Typography } from '@sb/cc-design-system';

export const modalDialogProps = {
  sx: {
    '& .MuiDialog-paper': {
      borderRadius: '8px 8px 32px 32px',
    },
  },
};

export const modalHeaderStyle = {
  alignItems: 'center',
  padding: '25px',
};

export const modalFooterStyle = {
  padding: '16px 24px 20px 20px',
};

export const ProductListModalContent = styled(Box)<{ $hasResult: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  padding: ${({ $hasResult }: { $hasResult: boolean }) =>
    $hasResult ? '4px 8px 0' : '4px 8px'};
`;

export const SearchFilterChips = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;

  .MuiChip-root {
    height: 24px;
    border-radius: 12px;
  }
`;

export const ProductTable = styled(Box)(
  ({ theme }) => `
  border: 2px solid ${theme.palette.divider};
  border-radius: 10px;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin-top: 16px;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  width: 100%;
`,
);

export const ProductTableHead = styled(Box)(
  ({ theme }) => `
  align-items: center;
  background: ${theme.palette.grey[200]};
  border-bottom: 1px solid ${theme.palette.divider};
  column-gap: 24px;
  display: grid;
  grid-template-columns: minmax(240px, 320px) minmax(0, 1fr);
  min-height: 56px;
  padding: 0 56px 0 28px;

  > * {
    min-width: 0;
  }
`,
);

export const ProductTableHeadingText = styled(Typography)`
  padding: 16px 0;
`;

export const ProductRows = styled(Box)`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;

export const ProductRow = styled(Box)<{
  $selected: boolean;
}>(
  ({ $selected, theme }) => `
  align-items: start;
  background: ${
    $selected ? theme.palette.primary.light : theme.palette.common.white
  };
  border-bottom: 1px solid ${theme.palette.divider};
  column-gap: 24px;
  cursor: pointer;
  display: grid;
  grid-template-columns: minmax(240px, 320px) minmax(0, 1fr);
  min-height: 52px;
  padding: 14px 16px 14px 28px;

  > * {
    min-width: 0;
  }

  &:hover {
    background: ${
      $selected ? theme.palette.primary.light : theme.palette.action.hover
    };
  }
`,
);

export const ProductNameWrapper = styled(Box)`
  align-items: start;
  display: flex;
  gap: 16px;
  min-width: 0;

  .MuiCheckbox-root,
  .MuiRadio-root {
    height: 24px;
    padding: 0;
    width: 24px;
  }
`;

export const ProductNameContent = styled(Box)`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const ProductNameText = styled(Typography)`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const VariantChipsWrapper = styled(Box)`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
`;

export const VariantCount = styled(Typography)(
  ({ theme }) => `
  color: ${theme.palette.text.secondary};
  white-space: nowrap;
`,
);

export const VariantCountWrapper = styled(Box)`
  align-items: center;
  display: flex;
  gap: 4px;
`;

export const LoadingWrapper = styled(Box)`
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  min-height: 120px;
  padding: 32px 0;
`;

export const NoResultsWrapper = styled(Box)`
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-start;
  min-height: 0;
  padding: 20px;
`;
